module.exports = __webpack_public_path__ + "img/img71.2354a8a4.png";